import { Navigate, Route, Routes } from "react-router-dom";
import BetaSignUp from "./screens/BetaSignUp";
import BetaSignUpAccount from "./screens/BetaSignUpAccount";
import { useKissMetrics } from "hooks/kissmetrics";
import { CartContainer } from "screens/Cart/CartContainer";
import { ExternalAuthRegister } from "screens/externalAuthRegister/ExternalAuthRegister";
import SignUpScreen from "screens/signup/SignUpScreen";
import { setFullStoryEnv, useMount } from "ui.common";

const App: React.FC = () => {
  useKissMetrics();

  useMount(() => {
    setFullStoryEnv();
  });

  return (
    <Routes>
      <Route path="/" element={<External />} />
      <Route path="/account" element={<BetaSignUpAccount />} />
      <Route path="/beta-sign-up" element={<BetaSignUp />} />
      <Route path="/signup" element={<SignUpScreen />} />
      <Route path="/externalRegister" element={<ExternalAuthRegister />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

function External() {
  window.location.replace("https://solveiq.com");
  return null;
}

export default App;
